import React from 'react';
import styled from 'styled-components';
import { useImages } from '../hooks/useImages';
import { ReactComponent as ArrowBack } from '../assets/svg/arrow-back-lite.svg';
import { useHistory } from 'react-router-dom';

const Contact = () => {
  let history = useHistory();

  const image = 'contact.jpg';
  const images = useImages([image]);

  const isLoaded = images[image] !== undefined;

  return (
    <Container>
      {isLoaded ? (
        <Wrapper>
          <BackIcon as={ArrowBack} onClick={() => history.goBack()} />
          <Image src={images[image]} />
        </Wrapper>
      ) : (
        <Spinner src='loading.gif' />
      )}
    </Container>
  );
};

const Container = styled.div`
  min-height: 100vh;
  display: flex;
  justify-content: center;
`;

const Wrapper = styled.div`
  padding: 5px 5px;
  box-sizing: border-box;
  max-width: 400px;
  width: 100%;
`;

const Image = styled.img`
  width: 100%;
`;

const Spinner = styled.img`
  margin: auto;
  width: 25px;
  height: 25px;
  display: block;
`;

const BackIcon = styled.div`
  width: 20px;
  height: 20px;
  min-width: 20px;
  min-height: 20px;
  padding: 10px;
  cursor: pointer;
  fill: rgba(0, 0, 0, 0.2);
  margin: 5px auto 5px 0;
`;

export default Contact;
